/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, ElementRef, ViewChild } from '@angular/core';
import { AppService } from 'app/services/app-service';
import { ActivatedRoute, NavigationEnd, Params } from '@angular/router';
import { DetailsPageComponent } from '../details-page/details-page.component';
import { MainFilterItem } from './MainFilterItem';
import { MAIN_FILTER_ITEMS } from './APP_DETAILS_CONFIG';
import { APP_INSIGHTS_PERMISSION } from 'app/models/User';
import { AuthState } from 'app/services/auth.service';
import { SideNavItem } from 'app/models/SideNavItem';
import { appDetailsNavItems } from './side-navigation-items';
import { StructuredAppData } from '../../../../services/page-meta.service';
import { LabelValue } from 'app/models/LabeLValue';

declare let jQuery: any;
declare let toastr: any;

export const TRACKING_ID = 'app_details_link';
export interface OsOption {
  text: string;
  active: boolean;
  value: string;
  hidden: boolean;
}

export interface AvailableFilter {
  appid: string;
  region: string;
  device?: string;
  month: string;
  monthLabel: string;
}
export interface AppFilter {
  appId?: string;
  region?: string;
  os?: string;
  device?: string;
  month?: string;
  country?: string;
  queryParams?: any;
}
export const OS_OPTIONS = [
  {
    text: '<img class="white mr-2" src="/assets/images/play-store.png" alt="Play Store Icon"> <img class="black mr-2" src="/assets/images/play-store.png" alt="Play Store Icon"> Google Play',
    textOnly: 'Android',
    active: true,
    value: 'android',
    hidden: false
  },
  {
    text: '<i class="fa fa-apple mr-2"></i> App Store',
    textOnly: 'iOS',
    active: true,
    value: 'ios',
    hidden: false
  }
];

@Component({
  selector: 'app-new-insights-app-details',
  templateUrl: './app-details.component.html',
  styleUrls: [
    '../details-page/details-page.component.scss',
    '../details-page/details-page-common.scss',
    './app-details.component.scss',
    '../details-page/details-page-responsive.component.scss'
  ]
})
export class AppDetailsComponent extends DetailsPageComponent {
  loadingProgressData = false;
  loading = true;
  loadingData = false;
  showNoDataFound = false;

  region: string;
  country: string;
  os: string;
  device: string;
  month: string;
  mainFilterItems: Array<MainFilterItem>;
  prevMainFilterItems: Array<MainFilterItem>;
  osOptions = [];

  tempFilter: AppFilter = {};

  document: any;

  regionIndex = 0;
  deviceIndex = 0;

  lastUpdateLabel: string;

  hideOverlap = true;

  monthLabel: string;
  appFiltersIndex = 0;
  availableFilters: Array<AvailableFilter> = [];

  hasDangerousPermissions: boolean;
  hasAdSpendPermission: boolean;

  loadingChangeLog = false;
  changeLogData: any;

  hasLimitedData: boolean;
  inputSearchOption: string;

  selectedCountry: any;

  cachedSegmentEvent = {};

  sideNavItems: SideNavItem[] = appDetailsNavItems;

  @ViewChild('changelogModal') changelogModal;

  constructor(
    private route: ActivatedRoute,
    private el: ElementRef,
    private _appService: AppService
  ) {
    super(route, el, APP_INSIGHTS_PERMISSION);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.document = this._el.nativeElement.ownerDocument;

    this.dataUpdateRequested = true;
    this.onNavigationEnd(null);
    this.trackingId = TRACKING_ID;
    this.type = 'app';
    this.cachedSegmentEvent = {};
  }

  onAuthStateChange(evt: AuthState) {
    this.searchApp(true);
  }

  onNavigationEnd(evt: NavigationEnd) {
    super.onNavigationEnd(evt);

    if (this.dataUpdateRequested && !this.loadingData) {
      this.dataUpdateRequested = false;

      this.searchApp().then(() => {
        this.scrollToInitialSection();
      });
    }
  }

  onQueryParamsChange(params: Params) {
    this.month = this.getValidMonthParam(params['month'] as string);
    this.country = params['country'] || 'GLOBAL';

    this.requestDataUpdate();
  }

  onParamsChange(params: Params) {
    this.appId = params['appid'];
    this.region = params['region'];
    this.os = params['os'];
    this.device = this.getValidDeviceParam(params['device'] as string);

    this.mainFilterItems = JSON.parse(JSON.stringify(MAIN_FILTER_ITEMS));

    this.hideOverlap = this.userService.hasPermission('mrtUserOverlap');
    this.hasAdSpendPermission = this.userService.appAdSpendEnabled();

    this.requestDataUpdate();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onWatchlistUpdate(evt: any) {
    if (
      evt.type === 'sync' ||
      (evt.follow.id === this.appId && evt.follow.type === 'app')
    ) {
      this.searchApp(true);
    }
  }

  showChangelog() {
    if (!this.changelogModal) return;

    jQuery(this.changelogModal.nativeElement).modal({
      backdrop: false,
      keyboard: true,
      focus: true,
      show: true
    });
  }

  goToSection(anchor: string) {
    this.scrollToSection(anchor.substr(1));
  }

  getAppName(): string {
    if (this.insightsData && this.insightsData.appOverview) {
      return this.insightsData.appOverview.title;
    } else {
      return '';
    }
  }

  getAppOS(): string {
    return this.os;
  }

  getStructuredData(): StructuredAppData {
    const structuredAppData: StructuredAppData = {
      name: this.getAppName(),
      os: this.getAppOS(),

      score: undefined,
      appStorePrice: undefined,
      appStoreRating: undefined,
      appStoreRatingCount: undefined,
      canonicalPath: this.getCanonicalPath(),
      ageGroup: this.insightsData?.appOverview?.ageGroup,
      image: this.insightsData?.appOverview?.icon,
      developerName: this.insightsData?.publisherOverview?.name,
      developerUrl: this.insightsData?.publisherOverview?.website,
      available: this.insightsData?.appOverview?.isExistInAppStore
    };

    if (this.insightsData.ranking?.final?.score != null) {
      structuredAppData.score = this.insightsData.ranking.final.score;
    } else if (this.insightsData.appOverview?.appStoreRating != null) {
      structuredAppData.appStoreRating =
        this.insightsData.appOverview.appStoreRating;
    }

    if (this.insightsData.appOverview.price != null) {
      structuredAppData.appStorePrice = this.insightsData.appOverview.price;
    }

    return structuredAppData;
  }

  async followApp() {
    if (!this.isProcessing) {
      if (this._authService.isAuthenticated()) {
        try {
          this._followService.updateProcessingFollow(true);
          await this._watchlistService.addFollow(
            this.appId,
            'app',
            this.getAppOS()
          );
          await this.getNumWatching(this.appId, 'apps');
          this._eventBus.updateEyeNumFollowing.emit(true);
          this._followService.updateProcessingFollow(false);
          const props = {
            appUrl: window.location.href
          };
          this._tracking.eventTrack('app_follow_success', props);
        } catch (error) {
          let message = 'Please try again next time.';

          if (error.status === 403) {
            const body = error.error;

            if (body.error === 'Quota Exceeded') {
              message = 'You have reached your limit of 10 follows.';
            }
          }

          const props = {
            appUrl: window.location.href,
            error: error
          };

          this._tracking.eventTrack('app_follow_failed', props);
          toastr.error(message, 'Follow Failed!', { timeOut: 2000 });
          console.log('error: ', error);
          await this._watchlistService.removeFollow(
            this.appId,
            'app',
            this.getAppOS()
          );
          this._followService.updateProcessingFollow(false);
        }
      } else {
        this._authService.signupWithFollow();
      }
    }
  }

  async unfollowApp() {
    if (!this.isProcessing) {
      try {
        this._followService.updateProcessingFollow(true);
        await this._watchlistService.removeFollow(
          this.appId,
          'app',
          this.getAppOS()
        );
        await this.getNumWatching(this.appId, 'apps');
        this._eventBus.updateEyeNumFollowing.emit(true);
        this._followService.updateProcessingFollow(false);
      } catch (error) {
        const props = {
          appUrl: window.location.href,
          error: error
        };
        this._tracking.eventTrack('app_unfollow_failed', props);
        toastr.error('Please try again next time.', 'UnFollow Failed!', {
          timeOut: 2000
        });
        console.log('error: ', error);
        this._followService.updateProcessingFollow(false);
      }
    }
  }

  searchApp(inBackground = false) {
    // this.loadingData = this.data === null || !this.data;
    // this.loadingProgressData = this.data !== null;
    this.loadingData = !inBackground;
    this.showNoDataFound = false;
    // Check if it has month options
    const monthFilter = this.mainFilterItems.filter(
      filter => filter.key === 'month'
    )[0];
    if (
      this.isFreemium ||
      (monthFilter && monthFilter.options && monthFilter.options.length > 0)
    ) {
      this._appService.setDevice(this.device);
      this._appService.setOs(this.os);
      this._appService.setRegion(this.region);
      if (!this.isFreemium && this.userService.appInsightsCountryEnabled()) {
        this._appService.setCountry(this.country);
      }

      const monthQparam: string = this._route.snapshot.queryParams['month'];
      const month: string = this.getValidMonthParam(monthQparam);
      this._appService.setMonth(month);

      this.getNumWatching(this.appId, 'apps');
      const isFollowing = this.updateFollowingState();

      // this.isFollowing lags behind searchApp's results,
      // use actual value here.
      this._appService.setFollowing(isFollowing);
      const p1 = this._appService
        .getAllData(this.appId)
        .then(res => {
          this.hasDangerousPermissions = false;
          if (
            res['appOverview'] &&
            res['appOverview']['appId'] &&
            res['appOverview']['appScope'] &&
            Object.keys(res['appOverview']['appScope']).length > 0
          ) {
            this.setAppData(res);

            if (
              this.insightsData['permissions'] &&
              this.insightsData['permissions']['all']
            ) {
              const dangerousPermissions = this.insightsData['permissions'][
                'all'
              ].filter(permission => {
                return (
                  permission.isDangerous &&
                  permission.effects &&
                  permission.effects.indexOf('Privacy') >= 0
                );
              });
              this.hasDangerousPermissions = dangerousPermissions.length > 0;
            }
          } else {
            this.loadingProgressData = false;
            if (
              res['appOverview'] &&
              res['appOverview']['appScope'] &&
              Object.keys(res['appOverview']['appScope']).length > 0
            ) {
              const appScope = res['appOverview']['appScope'];
              const regions = Object.keys(appScope);
              const region = regions[this.regionIndex];
              if (region) {
                const devices = appScope[region];
                const device = devices[this.deviceIndex];

                this.deviceIndex++;
                if (this.deviceIndex >= devices.length) {
                  this.regionIndex++;
                  this.deviceIndex = 0;
                }
                this.loadingData = false;
                let month = res['appOverview']['month'];
                month = month.replace('-', '');
                this._router.navigate(
                  ['/insight/apps', this.appId, region, this.os, device],
                  { queryParams: { month: month } }
                );
              }
            } else {
              this.appFiltersIndex = 0;
              this.availableFilters = [];
              this.osOptions = [];
              this.showNoDataFound = true;
              const monthFilter = this.mainFilterItems.filter(
                filter => filter.key === 'month'
              )[0];
              if (monthFilter?.selected) {
                this.monthLabel = monthFilter.selected.label;
              }
              this.findAvailableFilters(this.appId);
            }
          }
        })
        .catch(error => {
          console.log('SERVER ERROR: ' + JSON.stringify(error));
          if (error.status == 403) {
            this._eventBus.showQuotaError('Insufficient quota.');
          }
        });

      if (this._authService.isAuthenticated()) {
        this.loadingChangeLog = true;
        this._changelogService
          .getMobileAppChangeLog(
            this.appId,
            this.os,
            this.region,
            this.device,
            this.month
          )
          .then(res => {
            if (res && res['numFound'] > 0) {
              this.changeLogData = res['docs'];
              this.loadingChangeLog = false;
            }
          });
      }
      return p1;
    } else {
      return this._appService
        .getAvailableMonths()
        .then(res => {
          if (
            res &&
            res['availableMonths'] &&
            res['availableMonths'].length > 0
          ) {
            const availableMonths = res['availableMonths'];
            const monthFilter = this.mainFilterItems.filter(
              filter => filter.key === 'month'
            )[0];
            monthFilter.options = availableMonths;
            monthFilter.selected = availableMonths[0];
            const monthParamValue = this._route.snapshot.queryParams['month'];
            if (monthParamValue) {
              const foundOption = monthFilter.options.filter(
                option => option.value === monthParamValue
              )[0];
              if (foundOption) {
                monthFilter.selected = foundOption;
              }
            }
            this.month = monthFilter.selected.value;
            return this.searchApp();
          }
        })
        .catch(error => {
          console.log('SERVER ERROR: ' + JSON.stringify(error));
          this._eventBus.showServerError();
        });
    }
  }

  findAvailableFilters(appid: string) {
    if (!this.isFreemium) {
      this.getAvailableFilters(appid);
      return;
    }

    const regionFiltersLength = this.mainFilterItems.filter(
      filter => filter.key === 'region'
    )[0].options.length;
    if (this.appFiltersIndex < regionFiltersLength) {
      const device = this.mainFilterItems.filter(
        filter => filter.key === 'device'
      )[0].selected.value;
      const region = this.mainFilterItems.filter(
        filter => filter.key === 'region'
      )[0].options[this.appFiltersIndex].value;
      this._appService.setDevice(device);
      this._appService.setOs(this.os);
      this._appService.setRegion(region);
      this._appService.setMonth('');

      this._appService.getAllData(appid).then(res => {
        if (res != null && res['appOverview'] && res['appOverview']['appId']) {
          let month = res['appOverview']['month'];
          month = month.replace('-', '');
          this.month = month;
          let monthLabel = null;
          const foundMonth = this.mainFilterItems
            .filter(filter => filter.key === 'month')[0]
            .options.filter(option => option.value === month);
          if (foundMonth && foundMonth.length > 0) {
            monthLabel = foundMonth[0].label;
          }

          this.availableFilters.push({
            appid: appid,
            region: region,
            device: device,
            month: month,
            monthLabel: monthLabel
          });
        }

        this.appFiltersIndex++;
        this.findAvailableFilters(appid);
      });
    }
  }

  getAvailableFilters(appid: string) {
    this._appService
      .getAvailableFilters(appid)
      .then(res => {
        if (res != null && res['availableFilters']) {
          const monthFilter = this.getMainFilterItem(
            this.mainFilterItems,
            'month'
          );
          this.availableFilters = res['availableFilters'].map((filter: any) => {
            let month: string = filter.month;
            let monthLabel = null;
            if (month) {
              month = month.replace('-', '');
              this.month = month;
              monthLabel = this.getMonthLabel(monthFilter.options, month);
            }
            return {
              ...filter,
              appid: filter.appId,
              monthLabel: monthLabel
            };
          });
        }
      })
      .finally(() => {
        this.loading = false;
        this.loadingData = false;
      });
  }

  availableFilterClick(availableFilter: AvailableFilter) {
    this.showNoDataFound = false;
    this.loading = false;
    this.loadingData = false;
    this._router.navigate(
      [
        '/insight/apps',
        availableFilter.appid,
        availableFilter.region,
        this.os,
        availableFilter.device
      ],
      {
        queryParams: { month: this.month, country: this.country }
      }
    );
  }

  initMonthDropdown(monthParamValue: string) {
    const monthFilter = this.mainFilterItems.filter(
      filter => filter.key === 'month'
    )[0];
    if (monthFilter) {
      monthFilter.selected = monthFilter.options
        ? monthFilter.options[0]
        : null;
      if (monthParamValue && monthFilter.options) {
        const foundOption = monthFilter.options.filter(
          option => option.value === monthParamValue
        );
        if (foundOption && foundOption[0]) {
          monthFilter.selected = foundOption[0];
        }
      }
    }
  }

  setAppData(res: any) {
    const props = { appUrl: window.location.href };
    if (this.userService.session) {
      props['bundleid'] = res['appOverview']['appId'];
    }

    if (!this.cachedSegmentEvent[props.appUrl]) {
      this.cachedSegmentEvent[props.appUrl] = true;
      this._tracking.eventTrack('app_found', props);
    }

    this.insightsData = res;
    this.initAppData();
    this.loading = false;
    this.loadingData = false;
    this.loadingProgressData = false;
    this.initStoreOptions();
    this.initImgErrors();

    const monthQparam: string = this._route.snapshot.queryParams['month'];
    const validMonth: string = this.getValidMonthParam(monthQparam);
    if (!validMonth) {
      this._router.navigate(
        ['/insight/apps', this.appId, this.region, this.os, this.device],
        {
          queryParams: { month: null },
          queryParamsHandling: 'merge'
        }
      );

      this.initMonthDropdown('');
    } else {
      const currentMonth: string = this.insightsData['appOverview']['month'];
      if (currentMonth && currentMonth.length > 0) {
        this.initMonthDropdown(currentMonth.replace('-', ''));
      }
    }

    const datearr: string[] =
      this.insightsData['appOverview']['lastUpdatedDate'].split('-');
    const month = this.monthArray[Number.parseInt(datearr[1]) - 1];
    this.lastUpdateLabel = `${month} ${datearr[2]}, ${datearr[0]}`;

    const isSafari =
      !!navigator.userAgent.match(/safari/i) &&
      !navigator.userAgent.match(/chrome/i) &&
      typeof document.body.style.webkitFilter !== 'undefined';
    const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

    if (isSafari || isFirefox) {
      const rwIndex = this.insightsData['appOverview']['icon'].indexOf('-rw');
      const suggestionIcon = this.insightsData['appOverview']['icon'];
      if (rwIndex >= 0) {
        this.insightsData['appOverview']['icon'] = suggestionIcon.substring(
          0,
          rwIndex
        );
      }

      if (
        this.insightsData['appOverview']['screenshotUrls'] &&
        this.insightsData['appOverview']['screenshotUrls'].length > 0
      ) {
        const screenshots = [];
        this.insightsData['appOverview']['screenshotUrls'].forEach(
          screenshot => {
            const rwIndex = screenshot.indexOf('-rw');
            const suggestionIcon = screenshot;
            if (rwIndex >= 0) {
              screenshots.push(suggestionIcon.substring(0, rwIndex));
            } else {
              screenshots.push(screenshot);
            }
          }
        );
        this.insightsData['appOverview']['screenshotUrls'] = screenshots;
      }
    }

    this._eventBus.showFeedback();

    if (this.insightsData && this.insightsData.appOverview) {
      this.updatePageMetadata();
    }
  }

  getAppScope() {
    this._appService
      .getAppScopeData(
        this.appId,
        this.os,
        this.tempFilter.device,
        this.tempFilter.region,
        this.tempFilter.country,
        this.tempFilter.month
      )
      .then(res => {
        if (res['availableCountries']) {
          // Set Country Options if permission is enabled
          const countryFilter = this.mainFilterItems.filter(
            filter => filter.key === 'country'
          )[0];

          if (
            !this.isFreemium &&
            this.userService.appInsightsCountryEnabled()
          ) {
            const countryOptions: Array<LabelValue> = [];
            const availableCountries: any[] = res['availableCountries'];
            if (availableCountries?.length > 0) {
              availableCountries.forEach(reg => {
                const countryCode: string = reg['countryCode'];
                const regionText =
                  countryCode === 'GLOBAL'
                    ? 'All Countries'
                    : reg['countryName'];
                let label = `<img class="dropdown-item-flag" src="//cdn.pixalate.com/icons/countries/flat/48/${countryCode}.png" alt="Flag Icon"/> `;
                label += regionText;
                countryOptions.push({
                  label: countryCode !== 'GLOBAL' ? label : regionText,
                  value: countryCode
                });
              });
            }

            countryFilter.options = countryOptions;
            const foundFilter = countryOptions.filter(
              filter => filter.value === this.tempFilter.country
            );
            if (foundFilter && foundFilter[0]) {
              countryFilter.selected = foundFilter[0];
            } else {
              // current country selected is not listed on the available countries, have to reload data
              countryFilter.selected = countryOptions[0]; // set the first option
            }
          } else {
            countryFilter.disabled = true;
          }

          this.initTooltips();
        }
      });
  }

  initAppData() {
    let hasMismatchFilter = false;

    if (this.insightsData['appOverview']['appScope']) {
      this.hasLimitedData =
        this.insightsData['appOverview']['hasLimitedData'] !== 'N/A' &&
        this.insightsData['appOverview']['hasLimitedData'] === true;
      if (this.hasLimitedData) {
        this.device = 'GLOBAL';
        this.region = 'GLOBAL';
        this.country = 'GLOBAL';
      }

      // Set Region Options
      const regionFilter = this.mainFilterItems.filter(
        filter => filter.key === 'region'
      )[0];
      const regionOptions: Array<LabelValue> = [];
      Object.keys(this.insightsData['appOverview']['appScope']).forEach(reg => {
        regionOptions.push({
          label: reg === 'NA' ? 'North America' : reg,
          value: reg
        });
      });
      regionFilter.options = regionOptions;
      regionFilter.selected = regionOptions.filter(
        filter => filter.value === this.region
      )[0];

      // Set Country Options if permission is enabled
      const countryFilter = this.mainFilterItems.filter(
        filter => filter.key === 'country'
      )[0];
      if (!this.isFreemium && this.userService.appInsightsCountryEnabled()) {
        const countryOptions: Array<LabelValue> = [];
        if (
          this.insightsData['availableCountries'] &&
          this.insightsData['availableCountries'].length > 0
        ) {
          this.insightsData['availableCountries'].forEach(reg => {
            const regionText =
              reg['countryCode'] === 'GLOBAL'
                ? 'All Countries'
                : reg['countryName'];
            let label = `<img class="dropdown-item-flag" src="//cdn.pixalate.com/icons/countries/flat/48/${reg['countryCode']}.png" alt="Flag Icon"/> `;
            label += regionText;
            countryOptions.push({
              label: reg['countryCode'] !== 'GLOBAL' ? label : regionText,
              value: reg['countryCode']
            });
          });
        }

        countryFilter.options = countryOptions;
        const foundFilter = countryOptions.filter(
          filter => filter.value === this.country
        );
        if (foundFilter && foundFilter[0]) {
          countryFilter.selected = foundFilter[0];
        } else {
          // current country selected is not listed on the available countries, have to reload data
          countryFilter.selected = countryOptions[0]; // set the first option
          hasMismatchFilter = true;
        }
        this.selectedCountry = countryFilter.selected;
      } else {
        countryFilter.disabled = true;
      }

      // Set Device Options
      const deviceFilter = this.mainFilterItems.filter(
        filter => filter.key === 'device'
      )[0];

      let devices = [];
      if (this.insightsData['appOverview']['appScope'][this.region]) {
        devices = JSON.parse(
          JSON.stringify(
            this.insightsData['appOverview']['appScope'][this.region]
          )
        );
      } else {
        // Default to GLOBAL region
        const availableRegions = Object.keys(
          this.insightsData['appOverview']['appScope']
        );
        if (availableRegions.length > 0) {
          const firstRegion = availableRegions[0];
          const firstDevice =
            this.insightsData['appOverview']['appScope'][firstRegion][0];
          devices = JSON.parse(
            JSON.stringify(
              this.insightsData['appOverview']['appScope'][firstRegion]
            )
          );
          this.region = firstRegion;
          this.device = firstDevice;
          regionFilter.selected = regionOptions.filter(
            filter => filter.value === this.region
          )[0];
          hasMismatchFilter = true;
        }
      }

      if (devices.length <= 0) {
        this.hasLimitedData = true;
        this.device = 'GLOBAL';
        this.region = 'GLOBAL';
        this.country = 'GLOBAL';
      } else if (devices.length === 1) {
        this.device = devices[0];
      }
      regionFilter.hidden = this.hasLimitedData;
      countryFilter.hidden = this.hasLimitedData;
      deviceFilter.hidden = this.hasLimitedData;

      if (this.hasLimitedData === true) {
        devices.push('GLOBAL');
      }
      const deviceOptions: Array<LabelValue> = devices.map(device => {
        const label = device.charAt(0).toUpperCase() + device.substr(1);
        return {
          label: label === 'GLOBAL' ? 'All Devices' : label,
          value: device
        };
      });
      deviceFilter.options = [];
      deviceFilter.options = deviceFilter.options.concat(deviceOptions);
      deviceFilter.selected = deviceFilter.options.filter(
        filter => filter.value === this.device
      )[0];

      // Set Month filter if freemium disabled and show data response month
      if (this.isFreemium) {
        const currentMonth = this.insightsData['appOverview']['month'];
        const datearr = currentMonth.split('-');
        const month = this.monthArray[Number.parseInt(datearr[1]) - 1];
        const currentMonthLabel = `${month} ${datearr[0]}`;
        const currentMonthOption = {
          label: currentMonthLabel.toUpperCase(),
          value: currentMonth.replace('-', '')
        };
        const monthFilter = this.mainFilterItems.filter(
          filter => filter.key === 'month'
        )[0];
        monthFilter.options = [];
        monthFilter.options.push(currentMonthOption);
        monthFilter.selected = currentMonthOption;
        monthFilter.disabled = true;
      }

      // Check if has param action to follow/unfollow
      const action = this._route.snapshot.queryParams['action'];
      if (action && action.length > 0) {
        const extras = {
          queryParams: { action: null },
          preserveFragment: true
        };
        if (action === 'follow') {
          this.followApp().then(() => {
            this._router.navigate([], extras);
          });
        } else if (action === 'unfollow') {
          this.unfollowApp().then(() => {
            this._router.navigate([], extras);
          });
        }
      }

      this.initTooltips();
    }

    if (hasMismatchFilter) {
      // Reload filters based on the current selection
      this.selectMainFilter(null);
    }
  }

  dropdownClick($event, mainFilterItem: MainFilterItem, searchInputId: string) {
    if (mainFilterItem.options.length > 10) {
      setTimeout(() => {
        const input = jQuery(`#${searchInputId}`).get(0);
        if (input) {
          input.focus();
        }
        $event.preventDefault();
      }, 200);
    }
  }

  initStoreOptions() {
    this.osOptions = JSON.parse(JSON.stringify(OS_OPTIONS));
    this.osOptions.forEach(option => {
      if (option.value === this.os) {
        option.active = true;
      } else {
        option.active = false;
        if (
          this.insightsData['appOverview']['matchingAppIds'] &&
          this.insightsData['appOverview']['matchingAppIds'].length > 0
        ) {
        } else {
          option.hidden = true;
        }
      }
    });
  }

  showTooltip(mainFilterItem: MainFilterItem, event: any) {
    event.stopPropagation();
    mainFilterItem.highlighted = true;
    mainFilterItem.showTooltip = true;
    setTimeout(() => {
      mainFilterItem.showTooltip = false;
      mainFilterItem.highlighted = false;
    }, 2000);
  }

  selectedMainFilterItemClick(
    mainFilterItem: MainFilterItem,
    event: any,
    show = false
  ) {
    if (
      mainFilterItem.lockedIfFreemiumNotFollowing &&
      this.isFreemium &&
      !this.isFollowing
    ) {
      mainFilterItem.tooltip = 'Follow to Unlock';
      this.showTooltip(mainFilterItem, event);
      return;
    } else {
      // If country select, check if selected region is NOT GLOBAL, if GLOBAL, show tooltip
      if (mainFilterItem.key === 'country' && !mainFilterItem.disabled) {
        const regionFilter = this.mainFilterItems.filter(
          item => item.key === 'region'
        )[0];
        const region = regionFilter.selected.value;
        if (region === 'GLOBAL') {
          regionFilter.tooltip = 'Please select region';
          this.showTooltip(regionFilter, event);
        }
      } else if (mainFilterItem.disabled) {
        this.showTooltip(mainFilterItem, event);
      }
    }
    if (!mainFilterItem.disabled) {
      this.toggleDropdownOption(mainFilterItem, show);
    }
  }

  toggleDropdownOption(mainFilterItem: MainFilterItem, show: boolean) {
    mainFilterItem.show = show;
    this._mobileScrollService.toggleFilterOptions(show);
  }

  selectMainFilter(
    mainFilterItem?: MainFilterItem,
    selectedOption?: LabelValue,
    applyFilter = true
  ) {
    if (
      mainFilterItem === null ||
      (mainFilterItem &&
        mainFilterItem.selected &&
        mainFilterItem.selected.value !== selectedOption.value)
    ) {
      if (mainFilterItem && selectedOption) {
        mainFilterItem.selected = selectedOption;
        mainFilterItem.options.forEach(option => {
          option.selected = option.value === selectedOption.value;
        });
        if (applyFilter) {
          if (mainFilterItem.key === 'region') {
            this.region = mainFilterItem.selected.value;
          }
          if (mainFilterItem.key === 'device') {
            this.device = mainFilterItem.selected.value;
          }
          if (mainFilterItem.key === 'month') {
            this.month = mainFilterItem.selected.value;
          }
          if (mainFilterItem.key === 'country') {
            this.country = mainFilterItem.selected.value;
          }
        }
      }
      const region = this.mainFilterItems.filter(
        item => item.key === 'region'
      )[0].selected.value;
      let device = this.mainFilterItems.filter(item => item.key === 'device')[0]
        .selected.value;
      if (
        this.insightsData['appOverview']['appScope'] &&
        this.insightsData['appOverview']['appScope'][region]
      ) {
        const devices = JSON.parse(
          JSON.stringify(this.insightsData['appOverview']['appScope'][region])
        );
        if (devices.indexOf(device) < 0) {
          device = devices[0];
        }
      }

      let month = null;
      let country = null;
      if (!this.isFreemium) {
        month = this.mainFilterItems.filter(item => item.key === 'month')[0]
          .selected.value;
        if (!this.isFreemium && this.userService.appInsightsCountryEnabled()) {
          if (mainFilterItem && mainFilterItem.key === 'region') {
            country = 'GLOBAL';
          } else {
            const foundCountry = this.mainFilterItems.filter(
              item => item.key === 'country'
            );
            country =
              foundCountry && foundCountry[0] && foundCountry[0].selected
                ? foundCountry[0].selected.value
                : 'GLOBAL';
          }
        }
      }

      const queryParams = { month: month };
      if (!this.isFreemium && this.userService.appInsightsCountryEnabled()) {
        queryParams['country'] = country;
      }

      // Desktop
      if (applyFilter) {
        this._router.navigate(
          ['/insight/apps', this.appId, region, this.os, device],
          { queryParams: queryParams }
        );
      }
      // Mobile
      else {
        this.tempFilter = {
          device,
          region,
          country,
          month,
          queryParams
        };

        this.getAppScope();
      }
    }
  }

  showFilter() {
    this.prevMainFilterItems = JSON.parse(JSON.stringify(this.mainFilterItems));
    this.tempFilter = {
      device: this.device,
      region: this.region
    };
  }

  resetFilter() {
    this.mainFilterItems = JSON.parse(JSON.stringify(this.prevMainFilterItems));
  }

  applyFilter() {
    const { region, device, queryParams } = this.tempFilter;
    void this._router.navigate(
      ['/insight/apps', this.appId, region, this.os, device],
      { queryParams, queryParamsHandling: 'merge' }
    );
  }

  searchMainFilterItemOption(mainFilterItem: MainFilterItem, event: any) {
    const inputValue = jQuery(event.currentTarget).val();
    mainFilterItem.options.forEach(option => {
      if (option.value !== 'GLOBAL') {
        option.hidden =
          option.label.toLowerCase().indexOf(inputValue.toLowerCase()) < 0;
      }
    });
  }

  changeOs(os: string) {
    if (
      this.os !== os &&
      this.insightsData['appOverview']['matchingAppIds'] &&
      this.insightsData['appOverview']['matchingAppIds'].length > 0
    ) {
      this.appId = this.insightsData['appOverview']['matchingAppIds'][0];
      this.os = os;
      // this.loading = this.data === null || !this.data;
      // this.loadingProgressData = this.data !== null;
      this.loading = true;
      this.selectMainFilter(null);
    }
  }

  toAppDiscoveryClick(paramDetails: any) {
    const param = paramDetails.param;
    let paramValue = paramDetails.paramValue;
    if (paramDetails && param && paramValue && paramValue !== 'N/A') {
      if (paramValue === 'low') {
        paramValue = 'L';
      }
      if (paramValue === 'medium') {
        paramValue = 'M';
      }
      if (paramValue === 'high') {
        paramValue = 'H';
      }
      const queryParams = {};
      queryParams[param] = paramValue;
      jQuery('*[title]').tooltip('hide');
      this._router.navigate(
        ['/discovery/apps/list', this.os, 'all', this.region],
        { queryParams: queryParams }
      );
    }
  }
}
